import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable()
export class DownloadService {
  constructor(private _http: HttpClient) {
  }

  public download(fileName: string, data: any, url: string, headers?: HttpHeaders): Observable<boolean> {
    return this._loadFileAsBlob(data, url, headers)
    .pipe(map((file) => file && this.saveToFileSystem(fileName, file)));
  }

  public open(fileName: string, data: any, url: string, headers?: HttpHeaders): Observable<boolean> {
    return this._loadFileAsBlob(data, url, headers)
    .pipe(map((file) => file && this.openFileInNewTab(fileName, file)));
  }

  public saveOrOpenFile(fileName: string, blob: Blob): boolean {
    return this.saveToFileSystem(fileName, blob);
  }

  public saveToFileSystem(fileName: string, blob: Blob): boolean {
    const url = window.URL.createObjectURL(blob);
    const element = document.createElement('a');
    element.href = url;
    element.download = fileName;
    element.click();
    element.remove();
    URL.revokeObjectURL(url);
    return true;
  }

  public openFileInNewTab(fileName: string, blob: Blob): boolean {
    const url = window.URL.createObjectURL(blob);
    const obj = open(url, '_blank');
    obj.onload = () => {
      URL.revokeObjectURL(url);
    };
    return true;
  }

  private _loadFileAsBlob(data: any, url: string, headers?: HttpHeaders): Observable<Blob> {
    return this._http.post(url, data, {
      headers: this._ensureHeaders(headers),
      responseType: 'blob',
    });
  }

  private _ensureHeaders(headers: HttpHeaders): HttpHeaders {
    let result = headers;
    if (!result) {
      result = new HttpHeaders();
    }
    result.append('Content-Type', 'application/json');
    return result;
  }
}
